import { Box, Dialog, DialogActions, DialogContent } from '@mui/material';
import React from 'react';

import { DialogTitleWithClose } from '@/components/common/DialogTitleWithClose';

type Props = {
  open: boolean;
  title: string;
  onClose: () => void;
  fixedHeader?: React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  disableContentPadding?: boolean;
  'data-testid'?: string;
};

export function PartnerUpdateDialogShell({
  open,
  title,
  onClose,
  fixedHeader,
  children,
  actions,
  maxWidth = 'md',
  fullWidth = true,
  disableContentPadding = false,
  'data-testid': dataTestId,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      data-testid={dataTestId}
    >
      <DialogTitleWithClose onClose={onClose}>{title}</DialogTitleWithClose>

      {fixedHeader != null ? (
        <Box sx={{ px: 3, pt: 1, borderBottom: 1, borderColor: 'divider' }}>{fixedHeader}</Box>
      ) : null}

      <DialogContent sx={disableContentPadding ? { p: 0 } : undefined}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            ...(disableContentPadding ? { p: 2 } : {}),
          }}
        >
          {children}
        </Box>
      </DialogContent>

      {actions ? <DialogActions>{actions}</DialogActions> : null}
    </Dialog>
  );
}
